import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Add from "./Add";
import Edit from "./Edit";
import log from "../../lib/log";
import { loginState, configState } from "../../lib/State";
import token_login from "../../lib/token_login";
import get_session from "../../lib/get_session";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import CenterSelect from "../CenterSelect";
import pr from "../../lib/pr";
import get_login from "../../lib/get_login";
import is_admin from "../../lib/is_admin";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import Loading from "../Loading";
import Layout from "../Layout";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function List(props) {
  const {id} = props;
  const [seq, setSeq] = useState(0);
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const [rows, setRows] = useState([]);
  const [tcid, setTcid] = useState('');
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const token = localStorage.getItem("token");

  // 폼 데이타
  const [data, setData] = useState({
    gubun: ''
  });

  const onChangeData = (e) => {
    setData((state) => {
      return { ...state, [e.target.name]: e.target.value };
    });
  };

  const columns = [
    { field: "id", headerName: "id", hide: true },
    {
      field: "regdate",
      headerName: "등록일",
      width: 120,
    },
    {
      field: "title",
      headerName: "제목",
      minWidth: 600
    },

  ];

  const onCloseAddPop = () => {
    setOpenAdd(false);
    load_data();
  };

  const onOpenAdd = () => {
    setOpenAdd(true);
  };

  // 팝업 닫기
  const onCloseEditPop = () => {
    setOpenEdit(false);
    setSeq(0);
    load_data();
  };

  // 리스트
  const load_data = async () => {
    let result = await axios.post(configState.api + "/gympass_admin/board", {
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      tcid: tcid,
      gubun: data.gubun,
      id,
    });
    if (result.data.success === 1) {
      setRows(result.data.rows);
    }
  };

  // ======================= //
  // 로그인
  // ======================= //
  const start = async () => {
    let result;
    result = await get_login();
    setLogin(result.data.login);
    result = await is_admin(result.data.login);
    if (!result) {
      window.location.href = "/";
    }
    setLoaded(true);
  };
  useEffect(() => {
    start();
  }, []);

  // 리스트
  useEffect(() => {
    if(!login.mcd || !login.level ) return;
    load_data();    
  }, [login]);

  // 팝업처리
  const onSearchClick = async () => {
    load_data();
  };

  // 수정모드
  useEffect(() => {
    if (seq > 0) {
      setOpenEdit(true);
    }
  }, [seq]);

  return (
    <>
      {loaded === false ? (
        <Loading></Loading>
      ) : (
        <Layout login={login}>

          <h3
            css={css`
              margin-top: 10px;
            `}
          >
            가맹문의
          </h3>

          <Box
            display="flex"
            css={css`
              text-align: right;
              max-width: 1300px;
              margin-bottom: 15px;
            `}
          >
            {/* 센터명 */}
            <Box sx={{ flexGrow: 1 }}></Box>

            {/* <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={onOpenAdd}
            >
              코드추가
            </Button> */}
          </Box>

          <Box display="flex" sx={{ mb: 1 }}>
            {/* 구분 */}
            {/* <Box>
              <TextField
                sx={{ width: 120 }}
                name="gubun"
                label="구분"
                size="small"
                value={data.gubun}
                onChange={onChangeData}
                autoComplete="off"
              ></TextField>
            </Box> */}

            {/* 연락처 */}
            {/* <Box>
              <TextField
                sx={{ width: 160, ml: 1 }}
                name="sphone"
                label="연락처"
                size="small"
                onChange={onHandleData}
                autoComplete="off"
              ></TextField>
            </Box> */}
            {/* <Button
              sx={{ ml: 1, fontSize: 15 }}
              variant="contained"
              onClick={onSearchClick}
              size="small"
            >
              조회
            </Button> */}
          </Box>

          <DataGrid
            css={css`
              max-width: 1300px;
              min-height: 500px;
            `}
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            checkboxSelection={false}
            onRowClick={(params) => {
              setSeq(params.row.id);
              // setOpenEdit(true);
            }}
          />

          <Dialog
            open={openAdd}
            fullWidth={true}
            maxWidth="sm"
            TransitionComponent={Transition}
            onClose={() => { }}
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>추가</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseAddPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <Add
              tcid_parent = {tcid}
              login={login}
              onClosePop={onCloseAddPop}
            ></Add>
          </Dialog>

          <Dialog
            open={openEdit}
            TransitionComponent={Transition}
            onClose={() => { }}
            maxWidth="sm"
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>수정</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseEditPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <Edit
              login={login}
              seq={seq}
              onClosePop={onCloseEditPop}
            ></Edit>
          </Dialog>
        </Layout>
      )}
    </>
  );
}

export default List;
